// src/RegisterPage.js - NUOVO FILE

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { httpsCallable } from "firebase/functions";
import { functions, auth } from './firebase'; // Importa auth
import { signInWithEmailAndPassword } from "firebase/auth";

// Stili simili a LoginPage
const registerStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f2f2f2'
};
const formStyles = {
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    width: '350px',
    textAlign: 'center'
};
const inputStyles = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    boxSizing: 'border-box',
    borderRadius: '4px',
    border: '1px solid #ccc'
};
const buttonStyles = {
    width: '100%',
    padding: '10px',
    border: 'none',
    backgroundColor: '#d5a6bd',
    color: 'white',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px'
};
const errorStyles = {
    color: 'red',
    marginTop: '10px'
};
const linkStyles = {
    marginTop: '20px',
    fontSize: '0.9rem'
};

// Chiama la Cloud Function
const registerNewCenterFn = httpsCallable(functions, 'registerNewCenter');

function RegisterPage() {
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [centerName, setCenterName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    //const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!nome || !cognome || !centerName || !email || !password) {
            setError('Tutti i campi sono obbligatori.');
            return;
        }

        setIsLoading(true);

        try {
            // 1. Chiama la Cloud Function per creare tutto
            await registerNewCenterFn({
                ownerName: `${nome.trim()} ${cognome.trim()}`,
                ownerEmail: email.trim(),
                password: password,
                centerName: centerName.trim()
            });

            // 2. Se la funzione ha successo, l'utente Auth esiste.
            //    Ora esegui il login nell'app.
            await signInWithEmailAndPassword(auth, email.trim(), password);
            
            // 3. Il login è riuscito. L'onAuthStateChanged in UserContext
            //    rileverà il nuovo utente, caricherà il profilo (dal nuovo
            //    userLookup) e AppContent mostrerà la Dashboard.
            //    Non c'è bisogno di un 'navigate', il context gestirà il redirect.
            
            // (Non arriveremo qui se il login fallisce o il context reindirizza)

        } catch (err) {
            console.error("Errore di registrazione:", err);
            setError(err.message || 'Si è verificato un errore.');
            setIsLoading(false);
        }
    };

    return (
        <div style={registerStyles}>
            <form onSubmit={handleRegister} style={formStyles}>
                <h2>Registra Nuovo Centro</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <input
                        type="text"
                        placeholder="Nome Proprietario"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        style={inputStyles}
                        required
                    />
                    <input
                        type="text"
                        placeholder="Cognome Proprietario"
                        value={cognome}
                        onChange={(e) => setCognome(e.target.value)}
                        style={inputStyles}
                        required
                    />
                </div>
                <input
                    type="text"
                    placeholder="Nome del Nuovo Centro"
                    value={centerName}
                    onChange={(e) => setCenterName(e.target.value)}
                    style={inputStyles}
                    required
                />
                <input
                    type="email"
                    placeholder="Email Proprietario"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={inputStyles}
                    required
                />
                <input
                    type="password"
                    placeholder="Password (min. 6 caratteri)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={inputStyles}
                    required
                />
                <button type="submit" style={buttonStyles} disabled={isLoading}>
                    {isLoading ? 'Registrazione in corso...' : 'Registra'}
                </button>
                
                {error && <p style={errorStyles}>{error}</p>}
                
                <p style={linkStyles}>
                    Hai già un account? <Link to="/">Accedi</Link>
                </p>
            </form>
        </div>
    );
}

export default RegisterPage;